import { Component, OnInit, ViewChild } from '@angular/core';
import { confirm, alert } from 'devextreme/ui/dialog';
import { DxChartComponent, DxDataGridComponent } from '../../../../node_modules/devextreme-angular';
import { GenesisUnitOfWork, AuthService, AppInformationService } from '../../core/core.module';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Location } from '@angular/common';
import { Dealer, DealerAttachment, DealerTerm, SalesRep } from 'app/core/model/entity-model';
import { ShippingAddressDialogComponent } from 'app/admin/shipping-address-dialog/shipping-address-dialog.component';
import { AuditDialogComponent } from 'app/shared/audit-dialog/audit-dialog.component';
import { Subject } from 'rxjs';
import validationEngine from 'devextreme/ui/validation_engine';
import { environment } from 'environments/environment';
import _ from 'lodash';
import { PaymentCreditDialogComponent } from '../payment-credit-dialog/payment-credit-dialog.component';

@Component({
    selector: 'app-dealer-detail',
    templateUrl: './dealer-detail.component.html',
    styleUrls: ['./dealer-detail.component.scss'],
    standalone: false,
})
export class DealerDetailComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    showAsDialog = false;

    key: any;
    dealer: any;
    attachments: DealerAttachment[] = [];
    states: any;
    countries: any[] = ['US', 'CANADA', 'OTHER'];
    salesReps: SalesRep[];
    colors = ['red', 'blue', 'green', 'orange', 'white', 'gray'];
    terms: any[];
    shipAddressSelectedRowKeys: any[] = [];
    canEditAndDeleteShipAddress = false;
    readOnly = true;
    isActive = true;
    mileageRate = 0;
    discountMileageRate = 0;

    uploadHeader: any;
    uploadUrl = `${environment.serviceName}/file/SaveDealerAttachmentToBlobStorage`;

    salesSummary: any;
    salesSummaryWithoutZeros: any;
    achInfo: any;

    pricingTiers: any;
    sales: number;
    payments: number;
    invoices: number;
    qualifyingSales: number;

    canSeeSales = false;
    canUpdateTier = false;
    canSeeAdmin = false;

    @ViewChild('shippingAddressGrid') shippingAddressGrid: DxDataGridComponent;
    @ViewChild('salesChart') salesChart: DxChartComponent;

    constructor(
        private uow: GenesisUnitOfWork,
        private auth: AuthService,
        private route: ActivatedRoute,
        protected location: Location,
        private modalService: BsModalService,
        private appInfo: AppInformationService,
        private router: Router
    ) {}

    async ngOnInit() {
        this.uploadHeader = { Authorization: `Bearer ${this.auth.currentUser.jwtToken}` };
        this.states = this.uow.lookups.states;
        this.salesReps = this.uow.lookups.salesReps;
        this.mileageRate = ((await this.uow.getSettingsByName('MileageRate')) as any).decimalValue;
        this.discountMileageRate = ((await this.uow.getSettingsByName('DiscountMileageRate')) as any).decimalValue;
        this.readOnly = !this.auth.hasRole('Dealers:Admin');
        this.canSeeSales = this.auth.hasRole('Dealers:CanSeeSales');
        this.canUpdateTier = this.auth.hasRole('Dealers:CanChangeTier');
        this.canSeeAdmin = this.auth.hasRole('Dealers:Admin') || this.auth.hasRole('Administrator');
        this.terms = (await this.uow.dealerTerms.whereActive('displayOrder')) as any[];
        this.pricingTiers = this.uow.lookups.pricingTiers;

        if (!this.showAsDialog) this.key = this.route.snapshot.params['id'];
        if (this.key === 'new') {
            this.dealer = this.uow.dealers.createEntity();
            this.dealer.created = new Date();
            this.dealer.billState = 'MI';
            this.dealer.billCountry = 'US';
            this.dealer.freight = 0;
            this.dealer.terms = 'C.O.D.';
            this.dealer.dealerTermId = DealerTerm.Terms.COD;
        } else {
            const query = this.uow.dealers.baseQuery().expand(['shipAddresses']).where('id', '==', this.key);

            const dealers = await this.uow.dealers.executeQuery(query);
            this.dealer = dealers[0];
            this.isActive = !this.dealer.inactive;
            await this.getAttachments();

            if (!this.dealer.freight) this.dealer.freight = 0;
            this.dealer.calcFreight = this.dealer.loadedMiles * this.mileageRate;
            this.dealer.calcDiscountFreight = this.dealer.loadedMiles * this.discountMileageRate;
            await this.getSalesAndPaymentInformation();
            await this.getLatestAchInfo();

            if (this.dealer.id === Dealer.DealerOptions.Miscellaneous) {
                this.dealer.calcPricingTier = this.uow.lookups.pricingTiers.find((tier) => tier.id === 1);
            } else {
                const dealerSalesTier = await this.uow.getDealerTierBasedOnQualifyingSales(this.dealer.id);
                this.dealer.calcPricingTier = _.find(this.pricingTiers, (x) => {
                    return x.id === dealerSalesTier;
                });
                // this.dealer.calcPricingTier = this.uow.lookups.pricingTiers.find((tier) => this.qualifyingSales >= tier.minimumAmount && this.qualifyingSales < tier.maximumAmount);
            }
        }
    }

    async getSalesAndPaymentInformation() {
        this.salesSummary = await this.uow.getDealerSalesTotal(this.key);
        this.salesSummaryWithoutZeros = this.salesSummary.filter((x) => {
            if (x.orderTotal > 0) return x;
        });

        this.qualifyingSales = (await this.uow.getDealerYTDTierQualifyingSales(this.key)) ?? 0;

        this.sales = (await this.uow.getDealerYTDSalesOrders(this.key)) ?? 0;
        this.payments = (await this.uow.getDealerYTDPayments(this.key)) ?? 0;
        this.invoices = (await this.uow.getDealerYTDInvoices(this.key)) ?? 0;
    }

    async getLatestAchInfo() {
        // this.achInfo = await this.uow.getLatestAchInfo(this.dealer.id);
    }

    async getAttachments() {
        this.attachments = await this.uow.getDealerAttachments(this.dealer.id);
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }

    hasChanges() {
        return this.uow.hasChanges();
    }
    async afterSave() {
        this.shippingAddressGrid.instance.refresh();
    }

    selectionChange(e) {
        this.canEditAndDeleteShipAddress = this.shippingAddressGrid.instance.getSelectedRowsData().length === 1;
    }

    customizeToolTip = (e) => {
        return {
            text: e.seriesName + ' - ' + e.valueText,
        };
    };

    onPointClick(e) {
        this.toggleVisibility(e.target.series);
    }

    legendClickHandler(e) {
        this.toggleVisibility(e.target);
    }

    toggleVisibility(item) {
        if (item.isVisible()) {
            item.hide();
        } else {
            item.show();
        }
    }

    termsChanged(e) {
        if (!e.selectedItem) return;
        if (e.selectedItem.id === null) this.dealer.terms = null;
        else this.dealer.terms = e.selectedItem.name;
    }

    mileageChange(e) {
        this.dealer.calcFreight = this.dealer.loadedMiles * this.mileageRate;
        this.dealer.calcDiscountFreight = this.dealer.loadedMiles * this.discountMileageRate;
    }

    async save() {
        const success = this.validate();
        if (!success) return false;

        this.appInfo.pleaseWaitShow();
        this.dealer.quickBooksLastExport = null;
        this.dealer.quickBooksOnlineLastExport = null;
        await this.uow.commit([this.dealer]);
        if (this.key === 'new' && !this.showAsDialog) {
            this.router.navigate(['../' + this.dealer.id], { relativeTo: this.route, replaceUrl: true, state: { navigateOnSaveNew: true } });
        }
        this.key = this.dealer.id;
        this.appInfo.pleaseWaitHide();

        return true;
    }

    cancel() {
        this.dealer.entityAspect.rejectChanges();
        this.close();
    }

    close() {
        if (!this.isActive && this.hasChanges()) this.dealer.entityAspect.rejectChanges();
        try {
            this.location.back();
        } catch {
            this.router.navigate(['../'], { relativeTo: this.route });
        }
    }

    async rowDoubleClick(e) {
        if (!e.data || !e.data.id || !this.isActive) return;
        this.editShippingAddress(e.data);
    }

    async editShippingAddress(shipAddress?: any) {
        const success = await this.save();
        if (!success) return;

        const modalRef = this.modalService.show(ShippingAddressDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                shipAddress: shipAddress ? shipAddress : null,
                dealer: this.dealer,
            },
        });
        modalRef.content.result.subscribe((result) => {
            if (result) {
            }
        });
    }

    async deleteShippingAddress(entity) {
        if (!entity) return;

        const result = await confirm('Are you sure you want to delete this ship to address?', 'Delete Address');
        if (!result) return;

        entity.entityAspect.setDeleted();
        await this.uow.commit([entity]);
    }

    async auditLog() {
        const auditLogs = [];

        const dealerAudits = await this.uow.getHistory('Dealer', [this.dealer.id]);
        dealerAudits.forEach((audit) => {
            auditLogs.push(audit);
        });

        const shipAddressIds = this.dealer.shipAddresses.map((shipAddress) => {
            return shipAddress.id;
        });
        const shipAddressAudits = await this.uow.getHistory('ShipAddress', shipAddressIds);
        shipAddressAudits.forEach((audit) => {
            auditLogs.push(audit);
        });

        const modalRef = this.modalService.show(AuditDialogComponent, {
            class: 'modal-md',
            initialState: {
                auditLogs: auditLogs,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.result) {
            }
            modalRef.hide();
        });
    }

    async saveDialog() {
        if (!this.showAsDialog) return;

        const success = await this.save();
        if (!success) return;
        this.result.next({ success: true, dealer: this.dealer });
    }

    cancelDialog() {
        if (!this.showAsDialog) return;

        this.dealer.entityAspect.rejectChanges();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('dealerValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('dealerValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }

    uploadStarted(e) {
        this.appInfo.pleaseWaitShow();
    }

    async uploaded(e) {
        if (e?.request?.responseText) {
            const fileResponses = JSON.parse(e.request.responseText) as { filename: string; name: string }[];
            for (const fileResponse of fileResponses) {
                const attachment = this.uow.dealerAttachments.createEntity({
                    dealerId: this.dealer.id,
                    name: fileResponse.name,
                    filename: fileResponse.filename,
                    created: new Date(),
                    createdBy: this.auth.currentUser.userName,
                }) as DealerAttachment;
                this.attachments.push(attachment);
                await this.uow.commit([attachment]);
            }
            this.attachments = _(this.attachments).orderBy('name').valueOf();
        }
        this.appInfo.pleaseWaitHide();
    }

    uploadError(e) {
        this.appInfo.pleaseWaitHide();
        alert('An error occurred while attempting to upload the file(s)', 'Upload Error');
    }

    async removeAttachment(e: any, attachment: DealerAttachment) {
        e.preventDefault();
        attachment.deleted = new Date();
        this.attachments.splice(this.attachments.indexOf(attachment), 1);
        await this.uow.commit([attachment]);
    }

    openAttachment(attachment) {
        const dealerUrl = 'https://peccerium.blob.core.windows.net/genesis-trailers/dealer/attachments/';
        let fileName = attachment.filename.replace(dealerUrl, '');
        const fileNameURI = encodeURIComponent(fileName);
        const path = dealerUrl + fileNameURI;
        window.open(path, '_blank');
    }

    async validateDealer() {
        this.dealer.validated = new Date();
        await this.save();
    }

    async unValidateDealer() {
        this.dealer.validated = null;
        await this.save();
    }

    async createCredit() {
        const modalRef = this.modalService.show(PaymentCreditDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dealerId: this.dealer.id,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            modalRef.hide();
        });
    }

    async markReadyToExport() {
        const result = await confirm(`Are you sure you want to mark as Ready To Export for Quickbooks?`, `${this.appInfo.settings.company}`);
        if (!result) return;

        this.dealer.readyToExport = new Date();
        await this.uow.commit();
    }
}
